import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { tariffsApi } from '../client';
import type { Tariff, TariffCreateRequest, TariffUpdateRequest } from '../types';

export interface TariffListFilters {
  status?: string | null;
  is_default?: boolean | null;
}

const filters: TariffListFilters = {};

export function setTariffListFilters(next: TariffListFilters): void {
  Object.assign(filters, next);
}

export const tariffsAdapter: CrudAdapter<Tariff, TariffCreateRequest, TariffUpdateRequest> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await tariffsApi.GET('/tariffs/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
          status: filters.status ?? undefined,
          is_default: filters.is_default ?? undefined,
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async byKey(id) {
    const { data, error } = await tariffsApi.GET('/tariffs/{tariff_id}', {
      params: { path: { tariff_id: Number(id) } },
    });
    if (error) throw error;
    return data as Tariff;
  },
  async create(payload) {
    const { data, error } = await tariffsApi.POST('/tariffs/', { body: payload });
    if (error) throw error;
    return { id: data?.tariff_id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await tariffsApi.PUT('/tariffs/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as unknown as Tariff;
  },
  async remove(id) {
    const { error } = await tariffsApi.DELETE('/tariffs/{tariff_id}', {
      params: { path: { tariff_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const tariffsStore = useCrudDataSource(tariffsAdapter);
